import { queryClient } from '../components/queryClient';
import { INTERNAL } from '../components/settings/AccessPolicies/constants';
import { UserProfileService } from './userProfile.service';

export abstract class UserService {
  public static isInternal = async (): Promise<boolean> => {
    const data = await queryClient.ensureQueryData({ queryKey: ['currentUser'], queryFn: UserProfileService.getMyProfile });
    const groupsFromQuery = await queryClient.ensureQueryData({ queryKey: ['groups-key'], queryFn: UserProfileService.getAllUserGroups });

    const groups = groupsFromQuery || [];
    const internalGroups = groups.filter((group) => group.scope === INTERNAL);

    return internalGroups.some((group) => group.name === data.primary_group);
  };

  public static isInternalSync = (): boolean => {
    const data = queryClient.getQueryData(['currentUser']);
    const groupsFromQuery = queryClient.getQueryData(['groups-key']);

    const groups = groupsFromQuery || [];
    const internalGroups = groups.filter((group) => group.scope === INTERNAL);

    const isInternal = internalGroups.some((group) => group.name === data.primary_group);

    return isInternal;
  };
}
